import { render, staticRenderFns } from "./select-primary.vue?vue&type=template&id=f3676f54&scoped=true&"
import script from "./select-primary.vue?vue&type=script&lang=js&"
export * from "./select-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3676f54",
  null
  
)

export default component.exports